import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Form, Formik, Field } from "formik";
import { AddStaffSchema } from "../../utils/validation";
import {
  addStaff,
  uploadReset,
  editStaff,
  getAllStaffs,
  resetUser,
} from "../../redux/Actions/SingleUserActions";
import Alert from "../../utils/Alert";
import UserModal from "../../components/EmailModal/UserModal";
import ModalInput from "../../components/FormInput/ModalInput";
import { PropTypes } from "prop-types";

const AddStaff = ({
  showModal,
  hideModal,
  showEditModal,
  hideEditModal,
  addStaff,
  isLoading,
  addingSuccess,
  editStaff,
  isEditing,
  editingSuccess,
  uploadReset,
  getAllStaffs,
  firstName,
  lastName,
  staffEmail,
  staffPassword,
  staffId,
  resetUser,
}) => {
  const [state, setState] = useState({
    hide: true,
  });

  useEffect(
    () => {
      if (addingSuccess) {
        hideModal();
        Alert(true, "success", "Success message", "A new staff has been added.");
        document.getElementById("signform").reset();
        uploadReset();
        resetUser();
        let offset = 0;
        let limit = 10;
        getAllStaffs(offset, limit);
      }
    },
    // eslint-disable-next-line
    [addingSuccess]
  );

  useEffect(
    () => {
      if (editingSuccess) {
        hideEditModal();
        Alert(
          true,
          "success",
          "Success message",
          "Staff details successfully updated."
        );
        document.getElementById("editform").reset();
        uploadReset();
        resetUser();
        let offset = 0;
        let limit = 10;
        getAllStaffs(offset, limit);
      }
    },
    // eslint-disable-next-line
    [editingSuccess]
  );

  const handleClick = () => {
    setState({
      ...state,
      hide: !state.hide,
    });
  };

  return (
    <div>
      <UserModal
        open={showModal}
        close={hideModal}
        height={"739"}
        width={"555"}
      >
        <div className="modal-header">
          <h1>ADD NEW STAFF</h1>
        </div>

        <div>
          <Formik
            initialValues={{
              first_name: "",
              last_name: "",
              email: "",
              password: "",
            }}
            onSubmit={(values) => {
              const addStaffValues = {
                first_name: values.first_name,
                last_name: values.last_name,
                email: values.email.trim(),
                password: values.password,
              };
              addStaff(addStaffValues);
            }}
            validationSchema={AddStaffSchema}
          >
            {({ handleSubmit, isValid, dirty }) => {
              return (
                <Form id="signform">
                  <div className="modal-form">
                    <div className="form-grid-4">
                      <Field
                        name="first_name"
                        label="First Name"
                        placeholder="Enter first Name"
                        component={ModalInput}
                      />
                      <Field
                        name="last_name"
                        label="Last Name"
                        placeholder="Enter last Name"
                        component={ModalInput}
                      />
                    </div>
                    <div className="form-grid">
                      <Field
                        name="email"
                        label="Email Address"
                        placeholder="Enter email"
                        component={ModalInput}
                      />
                    </div>

                    <div className="modal-input-password">
                      <span onClick={handleClick}>
                        {state.hide ? "SHOW" : "HIDE"}
                      </span>
                      <Field
                        name="password"
                        label="Password"
                        placeholder="Enter Password"
                        type={state.hide ? "password" : "text"}
                        component={ModalInput}
                      />
                    </div>

                    <div className="form-grid-4">
                      <div className="modal-input-button">
                        <button
                          className="modal-close-button"
                          type="button"
                          onClick={hideModal}
                        >
                          CLOSE
                        </button>
                      </div>

                      <div className="modal-input-button">
                        <button
                          type="submit"
                          className="modal-action-button"
                          disabled={isLoading || !(isValid && dirty)}
                        >
                          CREATE
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </UserModal>

      <UserModal
        open={showEditModal}
        close={hideEditModal}
        height={"739"}
        width={"555"}
      >
        <div className="modal-header">
          <h1>EDIT STAFF</h1>
        </div>

        <div>
          <Formik
            enableReinitialize
            initialValues={{
              first_name: firstName,
              last_name: lastName,
              email: staffEmail,
              password: staffPassword,
            }}
            onSubmit={(values) => {
              const editStaffValues = {
                first_name: values.first_name,
                last_name: values.last_name,
                email: values.email.trim(),
                password: values.password,
              };
              editStaff(staffId, editStaffValues);
            }}
            validationSchema={AddStaffSchema}
          >
            {({ handleSubmit, isValid, dirty }) => {
              return (
                <Form id="editform">
                  <div className="modal-form">
                    <div className="form-grid-4">
                      <Field
                        name="first_name"
                        label="First Name"
                        placeholder="Enter first Name"
                        component={ModalInput}
                      />
                      <Field
                        name="last_name"
                        label="Last Name"
                        placeholder="Enter last Name"
                        component={ModalInput}
                      />
                    </div>
                    <div className="form-grid">
                      <Field
                        name="email"
                        label="Email Address"
                        placeholder="Enter email"
                        component={ModalInput}
                      />
                    </div>

                    <div className="modal-input-password">
                      <span className="handleClick" onClick={handleClick}>
                        {state.hide ? "SHOW" : "HIDE"}
                      </span>
                      <Field
                        name="password"
                        label="Password"
                        placeholder="Enter Password"
                        type={state.hide ? "password" : "text"}
                        component={ModalInput}
                      />
                    </div>

                    <div className="form-grid-4">
                      <div className="modal-input-button">
                        <button
                          className="modal-close-button"
                          type="button"
                          onClick={hideEditModal}
                        >
                          CLOSE
                        </button>
                      </div>

                      <div className="modal-input-button">
                        <button
                          type="submit"
                          className="modal-action-button"
                          disabled={isEditing || !(isValid && dirty)}
                        >
                          SAVE
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </UserModal>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  addStaff: (staff) => dispatch(addStaff(staff)),
  editStaff: (id, staff) => dispatch(editStaff(id, staff)),
  uploadReset: () => dispatch(uploadReset()),
  resetUser: () => dispatch(resetUser()),
  getAllStaffs: (offset, limit) => dispatch(getAllStaffs(offset, limit)),
});

const mapStateToProps = (state) => ({
  isLoading: state.singleUser.isAdding,
  addingSuccess: state.singleUser.addingSuccess,
  isEditing: state.singleStaff.isEditing,
  editingSuccess: state.singleStaff.editSuccess,
});

AddStaff.propTypes = {
  showModal: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func
  ]),
  hideModal: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func
  ]),
  showEditModal: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func
  ]),
  hideEditModal: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func
  ]),
  addStaff: PropTypes.func,
  isLoading: PropTypes.bool,
  addingSuccess: PropTypes.bool,
  editStaff: PropTypes.func,
  isEditing: PropTypes.bool,
  editingSuccess: PropTypes.bool,
  uploadReset: PropTypes.func,
  getAllStaffs: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  staffEmail: PropTypes.string,
  staffPassword: PropTypes.string,
  staffId: PropTypes.number,
  resetUser: PropTypes.func,
}

export default connect(mapStateToProps, mapDispatchToProps)(AddStaff);
